import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import RoleSwitcher from "./components/RoleSwitcher";
import Landing from "./pages/Landing";
import CustomerApp from "./pages/customer/CustomerApp";
import CrewApp from "./pages/crew/CrewApp";
import AdminApp from "./pages/admin/AdminApp";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#0B132B] text-slate-100">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/customer" element={<CustomerApp />} />
            <Route path="/crew" element={<CrewApp />} />
            <Route path="/admin" element={<AdminApp />} />
          </Routes>
          <RoleSwitcher />
        </div>
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
